import index from './src/index'

export default index
